import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'

function PuerperalPsychosis(props) {
    useEffect(() => {
    })
    return (
        <PageWrapper className={"dis-03-hepatitis-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Puerperal psychosis (puerperal psychosis)"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Postpartum psychosis is <b>a severe mental illness</b>. It starts suddenly in
                                    the days, or weeks, after having a baby. Symptoms vary, and can
                                    change rapidly. They can include high mood (mania), depression,
                                    confusion, hallucinations and delusions.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Puerperal-psychosis/1.png")} alt="Puerperal-psychosis" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p>A <b>low mood</b> – showing signs of depression, being withdrawn or tearful, lacking energy, having a loss
                                    of appetite, anxiety, agitation or trouble sleeping. sometimes a mixture of both a manic mood and a
                                    low mood - or rapidly changing moods. loss of inhibitions. feeling suspicious or fearful.</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Postpartum_psychosis">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default PuerperalPsychosis;